<template>
  <section
    id="schedule"
    class="co-bg-striped"
  >
    <div class="co-container-sm px-4 py-20">
      <!-- タイトル -->
      <h2 class="co-heading-2-caption">
        受講スケジュールのイメージ
      </h2>
      <h3
        class="co-display-12 mb-[3.25rem] text-center leading-base"
      >
        <slot name="heading3">
          2つのコースを受講するにあたり、
          <br class="hidden md:block">
          各サポートを受けられる期間をご確認ください。
        </slot>
      </h3>

      <!-- 受講スケジュールイメージ -->
      <div class="flex flex-col justify-center gap-8 md:gap-5 lg:flex-row">
        <!-- 左 -->
        <div class="w-full border-t-4 border-co-success-500 bg-white px-3 pb-2 pt-7 shadow">
          <h4 class="mb-3 text-center">
            いつでもご利用可能！
          </h4>
          <h5
            class="mb-7 text-center font-bold"
          >
            <slot name="heading5Left">
              カリキュラム閲覧
            </slot>
          </h5>
          <div class="mb-5 bg-co-gray-200 p-4">
            <!-- 3コース -->
            <div
              v-if="courseThree"
              class="te-chart-couse-three relative mb-4"
            >
              <!-- 罫線 -->
              <ul class="relative h-full list-none">
                <li class="te-chart-border-top absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-one absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-two absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-three absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-four absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-five absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-buttom absolute border-l border-dashed border-co-gray-300" />
              </ul>
              <!-- バー -->
              <div class="te-chart-bar-three absolute size-full text-center">
                <ul class="-mt-4">
                  <li
                    class="mb-7 mt-9 px-3 py-2 md:mt-7"
                    :style="{ backgroundColor: courseBgOne }"
                  >
                    <span class="flex items-center justify-center text-white">
                      <slot name="courseIcon1">
                        <FontAwesomeIcon
                          :icon="faGem"
                          class="fa-fw inline pr-2"
                        />
                      </slot>
                      いつでもご利用可能！
                    </span>
                  </li>
                  <li
                    class="my-7 px-3 py-2"
                    :style="{ backgroundColor: courseBgTwo }"
                  >
                    <span class="flex items-center justify-center text-white">
                      <slot name="courseIcon2">
                        <FontAwesomeIcon
                          :icon="faCode"
                          class="fa-fw inline pr-2"
                        />
                      </slot>
                      いつでもご利用可能！
                    </span>
                  </li>
                  <li
                    class="px-3 py-2"
                    :style="{ backgroundColor: courseBgThree }"
                  >
                    <span class="flex items-center justify-center text-white">
                      <slot name="courseIcon3">
                        <i
                          class="fa fa-object-group pr-2"
                          aria-hidden="true"
                        />
                      </slot>
                      いつでもご利用可能！
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <!-- 2コース -->
            <div
              v-else
              class="te-chart-couse-two relative mb-4"
            >
              <!-- 罫線 -->
              <ul class="relative h-full list-none">
                <li class="te-chart-border-top absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-one absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-two absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-three absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-four absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-five absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-buttom absolute border-l border-dashed border-co-gray-300" />
              </ul>
              <!-- バー -->
              <div class="te-chart-bar-two absolute size-full text-center">
                <ul class="list-none p-0">
                  <li
                    class="my-5 px-3 py-2"
                    :style="{ backgroundColor: courseBgOne }"
                  >
                    <span class="flex items-center justify-center text-white">
                      <slot name="courseIcon1">
                        <FontAwesomeIcon
                          :icon="faGem"
                          class="fa-fw inline pr-2"
                        />
                      </slot>
                      いつでもご利用可能！
                    </span>
                  </li>
                  <li
                    class="px-3 py-2"
                    :style="{ backgroundColor: courseBgTwo }"
                  >
                    <span class="flex items-center justify-center text-white">
                      <slot name="courseIcon2">
                        <FontAwesomeIcon
                          :icon="faCode"
                          class="fa-fw inline pr-2"
                        />
                      </slot>
                      いつでもご利用可能！
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="flex justify-between">
              <span class="co-display-13">
                受講開始
              </span>
              <span class="co-display-13">
                受講終了
              </span>
            </div>
          </div>
          <p class="mb-4">
            <slot name="descriptionLeft">
              カリキュラム閲覧は、受講期間内でいつでもご利用いただけます。並行して学習を進めて頂いても、片方のコースから学習をされても構いません。
            </slot>
          </p>
        </div>
        <!-- 右 -->
        <div class="w-full border-t-4 border-co-success-500 bg-white px-3 pb-2 pt-7 shadow">
          <h4 class="mb-3 text-center">
            <slot name="heading4Right">
              前半・後半に分けてしっかりサポート！
            </slot>
          </h4>
          <h5 class="mb-7 text-center font-bold">
            <slot name="heading5Right">
              メンタリング、チャットサポート、課題提出
            </slot>
          </h5>
          <div class="mb-5 bg-co-gray-200 p-4">
            <!-- 3コース -->
            <div
              v-if="courseThree"
              class="te-chart-couse-three relative mb-4"
            >
              <!-- 罫線 -->
              <ul class="relative h-full list-none">
                <li class="te-chart-border-top absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-one absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-two absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-three absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-four absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-five absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-buttom absolute border-l border-dashed border-co-gray-300" />
              </ul>
              <!-- バー -->
              <div class="te-chart-bar-three absolute size-full text-center">
                <ul class="te-chart-bar-mentoring-three list-none p-0">
                  <li
                    class="te-mentoring-width-three my-7 px-3 py-2"
                    :style="{ backgroundColor: courseBgOne }"
                  >
                    <span class="flex items-center justify-center text-white">
                      <slot name="courseIcon1">
                        <FontAwesomeIcon
                          :icon="faGem"
                          class="fa-fw inline pr-2"
                        />
                      </slot>
                      前半
                    </span>
                  </li>
                  <li
                    class="te-mentoring-width-three m-auto my-7 px-3 py-2"
                    :style="{ backgroundColor: courseBgTwo }"
                  >
                    <span class="flex items-center justify-center text-white">
                      <slot name="courseIcon2">
                        <FontAwesomeIcon
                          :icon="faCode"
                          class="fa-fw inline pr-2"
                        />
                      </slot>
                      中盤
                    </span>
                  </li>
                  <li
                    class="te-mentoring-width-three ml-auto px-3 py-2"
                    :style="{ backgroundColor: courseBgThree }"
                  >
                    <span class="flex items-center justify-center text-white">
                      <slot name="courseIcon3">
                        <FontAwesomeIcon
                          :icon="faObjectGroup"
                          class="fa-fw inline pr-2"
                        />
                      </slot>
                      後半
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <!-- 2コース -->
            <div
              v-else
              class="te-chart-couse-two relative mb-4"
            >
              <!-- 罫線 -->
              <ul class="relative h-full list-none">
                <li class="te-chart-border-top absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-one absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-two absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-three absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-four absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-five absolute border-l border-dashed border-co-gray-300" />
                <li class="te-chart-border-buttom absolute border-l border-dashed border-co-gray-300" />
              </ul>
              <!-- バー -->
              <div class="te-chart-bar-two absolute size-full text-center">
                <ul class="list-none p-0">
                  <li
                    class="my-5 w-1/2 px-3 py-2"
                    :style="{ backgroundColor: courseBgOne }"
                  >
                    <span class="flex items-center justify-center text-white">
                      <slot name="courseIcon1">
                        <FontAwesomeIcon
                          :icon="faGem"
                          class="fa-fw inline pr-2"
                        />
                      </slot>
                      前半
                    </span>
                  </li>
                  <li
                    class="ml-auto w-1/2 px-3 py-2"
                    :style="{ backgroundColor: courseBgTwo }"
                  >
                    <span class="flex items-center justify-center text-white">
                      <slot name="courseIcon2">
                        <FontAwesomeIcon
                          :icon="faCode"
                          class="fa-fw inline pr-2"
                        />
                      </slot>
                      後半
                    </span>
                  </li>
                </ul>
              </div>
            </div>

            <div class="flex justify-between">
              <span class="co-display-13">
                受講開始
              </span>
              <span class="co-display-13">
                受講終了
              </span>
            </div>
          </div>
          <p class="mb-4">
            <slot name="descriptionRight">
              説明文が入ります
            </slot>
          </p>
          <template v-if="$slots.notesRight">
            <p class="co-display-13 text-co-gray-500">
              <slot name="notesRight">
                注釈が入ります
              </slot>
            </p>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faGem } from '@awesome.me/kit-65d95819ce/icons/classic/regular'
import { faCode, faObjectGroup } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    return {
      faGem,
      faCode,
      faObjectGroup,
    }
  },
  props: {
    courseThree: { // 3コースの表示切り替え
      type: Boolean,
      default: false,
      required: false,
    },
    courseBgOne: { // コース背景色1
      type: String,
      default: '#e66f74',
      required: false,
    },
    courseBgTwo: { // コース背景色2
      type: String,
      default: '#777bb4',
      required: false,
    },
    courseBgThree: { // コース背景色3
      type: String,
      default: '#cdbf49',
      required: false,
    },
  },
  components: {
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
/* // チャート */
.te-chart-couse-two {
  height: 12.5rem;
}

.te-chart-couse-three {
  height: 13.75rem;
}

/* // チャート罫線 */
.te-chart-border-top {
  left: 0;
  height: inherit;
}

.te-chart-border-one {
  left: 16.6667%;
  height: inherit;
}

.te-chart-border-two {
  left: 33.3333%;
  height: inherit;
}

.te-chart-border-three {
  left: 50%;
  height: inherit;
}

.te-chart-border-four {
  left: 66.6667%;
  height: inherit;
}

.te-chart-border-five {
  left: 83.3333%;
  height: inherit;
}

.te-chart-border-buttom {
  left: 100%;
  height: inherit;
}

/* // バー */
.te-chart-bar-two {
  top: 1.875rem;
  left: 0;
}

.te-chart-bar-three {
  top: 0.25rem;
  left: 0;
}

.te-chart-bar-mentoring-three {
  margin-top: -0.625rem;
  @media (min-width: 576px) {
    margin-top: -1rem;
  }
}

.te-mentoring-width-three {
  width: 33.333%;
}
</style>
